import * as React from 'react';
import { jsx as _jsx } from "theme-ui/jsx-runtime";
import { jsxs as _jsxs } from "theme-ui/jsx-runtime";

var ProductTableDataTextSubscript = function ProductTableDataTextSubscript(_ref) {
  var text = _ref.text,
      subscript = _ref.subscript,
      headerImage = _ref.headerImage;
  return _jsxs("div", {
    children: [headerImage ? _jsx("span", {
      sx: {
        variant: 'compounds.product-table.variants.redesign.cellContent.content'
      },
      children: text
    }) : text, _jsx("span", {
      sx: {
        fontSize: headerImage ? 'sm' : ['xs', 'md']
      },
      children: ' ' + subscript
    })]
  });
};

var PlainProductTableDataTextSubscript = function PlainProductTableDataTextSubscript(props) {
  var text = props.text,
      subscript = props.subscript;
  return "".concat(text, " ").concat(subscript);
};

export default ProductTableDataTextSubscript;
export var Rich = ProductTableDataTextSubscript;
export var Plain = PlainProductTableDataTextSubscript;
//# sourceMappingURL=data-text-subscript.js.map